import MaskMoney from "./maskMoney";

const calculateMenuItemPrice = (product) => {
  let requiredMinValue = 0;
  if (product.category?.price_method === 2) {
    for (let i = 0; i < product.requireds.length; i++) {
      let minValueRequired = null;
      for (let j = 0; j < product.requireds[i].groupsOptions.length; j++) {
        for (
          let k = 0;
          k < product.requireds[i].groupsOptions[j].options.length;
          k++
        ) {
          if (
            minValueRequired === null ||
            product.requireds[i].groupsOptions[j].options[k].price <
              minValueRequired
          ) {
            minValueRequired =
              product.requireds[i].groupsOptions[j].options[k].price;
          }
        }
      }

      requiredMinValue += minValueRequired * product.requireds[i].numChoose;
    }
    let finalPrice = requiredMinValue + product.price;

    return MaskMoney(finalPrice);
  } else {
    const rangeArray = product.priceRange.split(" - ");
    const price = Number.parseFloat(
      rangeArray[0].replace("R$ ", "").replace(".", "").replace(",", "."),
    );
    return MaskMoney(price);
  }
};

export default calculateMenuItemPrice;
